/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import AppForm from '@core/components/AppForm.vue'
import { IDateService } from '@master/services/IDateService'
import AIOICKA from '../views/AIOICKA.vue'
import F2FVerify from '../views/F2FVerify.vue'
import Screenings from '../views/Screenings.vue'
import { namespace } from 'vuex-class'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { FormStructure } from '@master/model/structure/FormStructure'
import { HRCRoleOptions } from '@master/model/options/HRCRoleOptions'
import { ClientDto } from '@core/pages/client-management/api'
import { RiskRatingOptions } from '@master/model/kyc-form/AML'

const clientInfoStore = namespace('ClientInfoStore')
@Component({
  components: {
    AppForm,
    AIOICKA,
    F2FVerify,
    Screenings
  }
})
export class ClientRisksMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @clientInfoStore.State
  private clientDto: ClientDto

  @clientInfoStore.Action
  private updateClientDTOV2

  @clientInfoStore.State
  private readOnly

  mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
  }

  formattedDate (unixTime: number | string) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  get curUser () {
    return this.$store.getters.currentUser
  }

  get isSuperUser () {
    return this.curUser?.isSuperUser || false
  }

  get policyOid () {
    return this.$route.params.policyOid
  }

  get clientOid () {
    return this.$route.params.clientOid
  }

  get hrcStructure (): FormStructure<ClientDto> {
    return [
      {
        label: 'HRT',
        key: 'hrcRoles',
        type: 'multi',
        options: HRCRoleOptions
      },
      {
        label: 'AML Risk Rating',
        model: {
          get: () => {
            return this.clientDto.personalInfoJson.amlRiskRating
          },
          set: (val) => {
            this.clientDto.personalInfoJson.amlRiskRating = val
          }
        },
        options: RiskRatingOptions.map(op => {
          return {
            label: op,
            value: op
          }
        })
      }
    ]
  }

  async save () {
    if (this.clientDto.ftfPerformedBy && !this.clientDto.ftfDateOfVerification) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please include a date for the face-to-face verification.'
      })
      return
    }
    await this.updateClientDTOV2(this.clientDto)
  }
}
